<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="6">功能选择</el-col>
      <el-col :span="18"style="text-align: center;width: 40%;">列表</el-col>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"

              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="step"  filterable placeholder="请选择步骤" @change="onChangeStripe">
              <el-option
                v-for="item in steps"
                :key="item.name"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
      </el-col>

      <el-col :span="16" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 40%;">


        <el-row  class="tui-el">
          <el-col :span="18" style="text-align: center;">名称</el-col>

          <el-col :span="6" style="text-align: center;">操作</el-col>
        </el-row>
        <el-row  class="tui-el">
          <el-col :span="18" style="text-align: center;line-height: 60px;"><input type="text" v-model="newName" @change="onImage()"></el-col>


          <el-col :span="6" ><input type="button" style="position: absolute;right: 40px;top: 15px;" @click="add()" value="添加"></el-col>
        </el-row>
        <el-row  class="tui-el" v-for="(item,index) in list" :key="index">
          <el-col :span="18" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>


          <el-col :span="6" style="text-align: center;line-height: 60px;" @click.native="del(item.id,index)">删除</el-col>
        </el-row>
      </el-col>


    </el-row>
    <el-dialog
      title="排序"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text"  class="searchTsx" v-model="addSort"/>

      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dosort()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [],
        delId:'',
        delIndex:'',
        addSort:0,
        dialogVisible:false,
        centerDialogVisible:false,
        paiId:0,
        value: '',
        step:1,
        steps:[{'name':'第一步','value':1},{'name':'第二步','value':2},{'name':'第三步','value':3},{'name':'第四步','value':4}],
        addImg:'',
        addImgs:'',
        newName:'',
        newImage:'',
        imageId: 0,
        list: [{
          img: 'http://y31p.yoooooo.com/static/xitong/zhishiwenda.png',

          name: '黄金糕'
        }, {
          img: 'http://y31p.yoooooo.com/static/xitong/shici.png',

          name: '双皮奶'
        }, {
          img: 'http://y31p.yoooooo.com/static/xitong/changtuqiche.png',

          name: '蚵仔煎'
        }],
        search:''

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{

    onChangeStripe(){
      this.loadList()
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']
        this.loadList()
    	})
    	.catch(err=>{

    	});
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          l_id:this.value,
          step:this.step
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/checkeListF'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },

    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/checkfDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }

      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/checkfAdd',
      	params:{
      		name:this.newName,
      		step:this.step,
          l_id:this.value
      	}
      })
      .then(res=>{

        this.newName = ''
        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },
    ceshi(id,val){
      //Tarr和Farr一定是没有交集的，最后的结果俩个数组都是做出改变后的，没有动的id是不包含在内的
      if(val){//当滑块为真得时候
        this.Tarr.push(id)//存入数组Tarr
        if(this.Farr.indexOf(id)>-1){//判断Farr里面是否有这个id如果有就移除
          this.Farr.splice(this.Farr.indexOf(id),1)
        }
      }else{//当滑块为假得时候
        this.Farr.push(id)//存入数组Tarr
        if(this.Tarr.indexOf(id)>-1){//判断Farr里面是否有这个id如果有就移除
          this.Tarr.splice(this.Tarr.indexOf(id),1)
        }
      }
    }

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/comgf.vue